export const icerikler = {
  title: 'İçerikler',
  titleEN: 'Content',
  description: 'Markanın hedef kitlesine gre liste ve quiz formatında hazırlanan, kullanıcıya olumlu bir Mynet içeriği tecrbesi yaşatırken bir yandan native olarak marka ile tketiciyi buluşturan içerik modelidir.',
  descriptionEN: 'Content model designed in a list and quiz format according to the brand\'s target audience, providing users with a positive Onedio experience while natively connecting the brand with the consumer.',
  tabs: [
    {
      id: 1,
      title: 'Advertorial',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/e81a9a055ac2b9150d2363c65712124dfdf1f2b90c4b44726da05f5ec8e74356.png',
          modal: 'image',
          modalTitle: 'Mynet Kadın',
          category: 'Mynet Kadın'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/c5a5ff7824a1e57f6bcbc8bf9d4de42436fbbf36c89b6683131f47af466f4566.png',
          modal: 'image',
          modalTitle: 'Anasayfa',
          category: 'Anasayfa'
        },
        {
          id: 3,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/cf3fd5dd67fb40347f91b1b6f024865e2c0582f016682dff6c8b4072f18aeb24.png',
          modal: 'image',
          modalTitle: 'Mynet Finans',
          category: 'Mynet Finans'
        }
      ]
    },
    {
      id: 2,
      title: 'Category',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/ffb55bcdc69adfca6db4644362f0ce2fc94b3986d3fe1feae80a03b89715c6c9.png',
          modal: 'image',
          modalTitle: 'CIF Yemek Kategori',
          category: 'CIF Yemek Kategori'
        },
      ]
    },
    {
      id: 3,
      title: 'Liste ve Test İçeriği',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/683b7e777cd082012fe2ae7a0997163538b5074cadc916cf7f611c78b1f007d8.png',
          url: 'https://www.mynet.com/istanbul-da-yasayan-herkesin-bir-altin-madalyayi-hak-ettigini-kanitlayan-7-an-110107172055',
          category: 'Liste İçeriği'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/42ccc73e623ab576f1d9e4d3796802c8a8ac2105ddee384a094baaa8216e6c84.png',
          url: 'https://www.mynet.com/6-soruda-sevdiklerinin-yuzunu-gulumsetmek-icin-yilbasinda-alman-gereken-hediyeyi-soyluyoruz-110107172110',
          category: 'Test İçeriği'
        },
      ]
    },
  ],
  egTabs: [
    {
      id: 1,
      title: 'Advertorial',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/e81a9a055ac2b9150d2363c65712124dfdf1f2b90c4b44726da05f5ec8e74356.png',
          modal: 'image',
          modalTitle: 'Mynet Women',
          category: 'Mynet Women'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/c5a5ff7824a1e57f6bcbc8bf9d4de42436fbbf36c89b6683131f47af466f4566.png',
          modal: 'image',
          modalTitle: 'Homepage',
          category: 'Homepage'
        },
        {
          id: 3,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/cf3fd5dd67fb40347f91b1b6f024865e2c0582f016682dff6c8b4072f18aeb24.png',
          modal: 'image',
          modalTitle: 'Mynet Finance',
          category: 'Mynet Finance'
        }
      ]
    },
    {
      id: 2,
      title: 'Category',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/ffb55bcdc69adfca6db4644362f0ce2fc94b3986d3fe1feae80a03b89715c6c9.png',
          modal: 'image',
          modalTitle: 'CIF Food Category',
          category: 'CIF Food Category'
        },
      ]
    },
    {
      id: 3,
      title: 'List and Test Contents',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/683b7e777cd082012fe2ae7a0997163538b5074cadc916cf7f611c78b1f007d8.png',
          url: 'https://www.mynet.com/istanbul-da-yasayan-herkesin-bir-altin-madalyayi-hak-ettigini-kanitlayan-7-an-110107172055',
          category: 'List Content'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/42ccc73e623ab576f1d9e4d3796802c8a8ac2105ddee384a094baaa8216e6c84.png',
          url: 'https://www.mynet.com/6-soruda-sevdiklerinin-yuzunu-gulumsetmek-icin-yilbasinda-alman-gereken-hediyeyi-soyluyoruz-110107172110',
          category: 'Test Content'
        },
      ]
    },
  ],
}
